import { styled } from '@mui/material';
import { useNavigationGuard } from 'contexts/navigationGuard';
import { forwardRef } from 'react';
import { useHistory } from 'react-router-dom';
import Button from 'shell/components/Button';
import Stack from 'shell/components/Stack';
import Text from 'shell/components/Text';

const CustomStack = styled(Stack)(() => {
    return {
        height: '4rem',
    };
});

const CustomButton = styled(Button)(({ $active, theme }) => {
    return {
        border: '1px solid transparent !important',
        color: theme.palette.ensightful.neutral[700],
        paddingBlock: '10px',
        paddingInline: 'clamp(0.5rem, 1.5cqi, 1rem)',
        whiteSpace: 'nowrap',
        transition: 'none',
        '& svg': {
            marginTop: '-0.125rem !important',
            marginRight: '0.125rem !important',
            fontSize: '1.5rem !important',
        },
        '&:hover': {
            color: `${theme.palette.ensightful.primary[500]} !important`,
        },
        ...($active && {
            color: `${theme.palette.ensightful.primary[500]} !important`,
            border: `1px solid ${theme.palette.ensightful.primary[500]} !important`,
        }),
    };
});

const NavButton = forwardRef(({ children, active, startIcon, to, ...rest }, ref) => {
    const history = useHistory();
    const { guard } = useNavigationGuard();

    return (
        <CustomStack alignItems={'center'} justifyContent={'center'} {...rest}>
            <CustomButton
                ref={ref}
                $active={active}
                color={'neutral'}
                startIcon={startIcon}
                variant={'tertiary'}
                onClick={() => guard(() => history.push(to))}
            >
                <Text
                    color={'inherit'}
                    variant={'p1'}
                    weight={'semibold'}
                    sx={{ fontSize: 'clamp(0.875rem, 1.2cqi, 1rem)' }}
                >
                    {children}
                </Text>
            </CustomButton>
        </CustomStack>
    );
});

export default NavButton;
